import React, { useState, useEffect } from 'react';
import MDBox from 'components/MDBox';
import Card from '@mui/material/Card';
import { useSelector } from 'react-redux';
import { Container } from 'components/Ui/styled';
import { useNotification } from 'utils/commonUtils';
import MyProfileTab from './myProfileTab/MyProfileTab';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import CustomizedSnackbars from 'components/snackbar/Snackbar';
import { getProfilePreferences } from './service/myProfileApi';
import MyProfileInfo from './components/myProfileInfo/MyProfileInfo';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import { usePermissionCustomHook } from 'layouts/users/userPermissions/utils/permissionsUtils';

const MyProfile = () => {
  const { handleErrorResponse, NotificationPopup } = useNotification();

  const [isLoading, setIsLoading] = useState(true);
  const [profilePreferences, setProfilePreferences] = useState(null);

  const myProfile = useSelector((state) => state.myProfile);

  const canAccessUserPreferences = usePermissionCustomHook(
    'CAN_ACCESS_USER_PREFERENCES'
  );

  useEffect(() => {
    if (myProfile) {
      if (canAccessUserPreferences) {
        fetchProfilePreferences();
      } else {
        setIsLoading(false);
      }
    }
  }, [myProfile]);

  const fetchProfilePreferences = async () => {
    try {
      const profilePreferences = await getProfilePreferences();
      setProfilePreferences(profilePreferences);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  return (
    <DashboardLayout>
      <CustomizedSnackbars />
      <DashboardNavbar />
      {/* <MyHeading />
          <MyCards /> */}
      <MDBox>
        <Card>
          <Container>
            <MyProfileTab
              profilePreferences={profilePreferences}
              setProfilePreferences={setProfilePreferences}
            />
          </Container>
        </Card>
      </MDBox>
      <NotificationPopup />
    </DashboardLayout>
  );
};

export default MyProfile;
